module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-detail-page"
  }, [_c('div', {
    staticClass: "header-area"
  }, [_c('header-return'), _vm._v(" "), _c('div', {
    staticClass: "header-body"
  }, [_c('div', {
    staticClass: "portrait-area"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.currentUser.username))])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "detail-items"
  }, [_c('li', {
    staticClass: "detail-item"
  }, [_c('span', {}, [_vm._v("用户名")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.currentUser.username))])]), _vm._v(" "), _c('li', {
    staticClass: "detail-item"
  }, [_c('span', {}, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.currentUser.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "logout-btn",
    on: {
      "click": _vm.showToast
    }
  }, [_vm._v("退出登录")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab4daa7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/account_detail.vue
// module id = 174
// module chunks = 1